<script>
export default {
  methods: {
    scrollToForm() {
      const el = document.getElementById("WaermeSignupForm");
      if (el) {
        window.scroll({ top: el.offsetTop, behavior: "smooth" });
      }
    }
  }
};
</script>

<template>
  <v-row>
    <v-col cols="12" md="6" class="pr-5 d-flex align-center">
      <div>
        <h1 class="heading-1 mb-4">Individuelle Wärmelösungen</h1>
        <p class="main-text">
          Zukunftssichere Wärmelösungen sind ein zentraler Baustein für die
          kommunale Energiewende. Ob Neubau, Quartiersentwicklung oder
          Bestandssanierung – wir unterstützen Kommunen und die
          Wohnungswirtschaft dabei, nachhaltige, wirtschaftliche und
          rechtssichere Wärmekonzepte umzusetzen.
        </p>
        <v-btn color="primary" class="text-none" @click="scrollToForm"
          >Jetzt anfragen</v-btn
        >
      </div>
    </v-col>
    <v-col cols="12" md="6">
      <img
        src="@/assets/waerme-img1-3_2v2.png"
        style="width: 100%; height: 100%;"
      />
    </v-col>
  </v-row>
</template>

<style scoped>
.heading-1 {
  font: normal normal 700 40px/48px "GeometriaGeometria";
  overflow-wrap: break-word;
}

@media (max-width: 600px) {
  .heading-1 {
    font-size: 35px;
    line-height: 40px;
  }
}

.main-text {
  font: normal normal 500 16px/24px "GeometriaGeometria" !important;
  letter-spacing: 0.32px;
  color: #1f2b37 !important;
}
</style>
